
import store from "../store";
import { gameActions } from '../Game/gameSlice';
import { useEffect, useReducer, useState } from "react";
import { SPRITESHEET_FILE } from "../Enums/ImageAssets";
import { AUDIO_ASSETS, LAZY_AUDIO_ASSETS } from "../Enums/AudioAssets";
import { IMAGE_ASSETS } from "../Enums/ImageAssets";

let preloadedCounter = 0;

function LoadingScreen() {

    const [, forceUpdate] = useReducer(x => x + 1, 0);
    const [isReady, setIsReady] = useState(false);

    useEffect(() => {

        const interval = setInterval(() => {
            preloadedCounter++;
            forceUpdate();
        }, 500);

        let isCancelled = false

        const imageAssetList = Object.keys(IMAGE_ASSETS);
        const audioAssetList = Object.keys(AUDIO_ASSETS);
        const lazyAudioAssetList = Object.keys(LAZY_AUDIO_ASSETS);

        async function effect() {

            if (isCancelled) {
                return
            }

            await preloadImage(SPRITESHEET_FILE);

            for (const image of imageAssetList) {
                await preloadImage(image);
            }

            // loading required sound assets
            for (const audio of audioAssetList) {
                await preloadAudio(audio);
            }

            if (isCancelled) {
                return
            }

            setIsReady(true);

            // lazy-loading sound assets only after initial loading is done
            for (const audio of lazyAudioAssetList) {
                await preloadAudio(audio);
            }
        };

        effect()

        return () => {
            isCancelled = true
            clearInterval(interval);
        }
    }, []);

    function printDots(num: number) {
        let dots = '';

        for (let i = 0; i <= num; i++) {
            dots += '.';
        }
        return dots;
    }

    function handleClick() {
        if (isReady) {
            finishLoadingGame();
        }
    }

    return (
        <div className="loading-screen" onClick={handleClick} style={{ cursor: isReady ? 'pointer' : 'default' }}>
            {!isReady && <div className="loading-screen_text">LOADING{printDots(preloadedCounter % 3)}</div>}
            {isReady && <div className="loading-screen_play button-text">PLAY</div>}
        </div>
    );
}

function preloadImage(src: string) {

    return new Promise((resolve, reject) => {
        const img = new Image()
        img.onload = function () {
            resolve(img)
        }
        img.onerror = img.onabort = function () {
            console.warn(`Failed to load image: ${src}`);
            resolve(null)
        }
        img.src = src
    })
}

function preloadAudio(src: string) {
    return new Promise((resolve, reject) => {
        const audio = new Audio();
        audio.addEventListener('canplaythrough', resolve, false);
        audio.addEventListener('error', () => {
            console.warn(`Failed to load audio: ${src}`);
            resolve(null);
        }, false);
        audio.src = src;
    })
}

function finishLoadingGame() {
    store.dispatch(gameActions.loadGame());
}

export default LoadingScreen;
